export default __webpack_public_path__ + "static/media/unit-result-fail-header.27934915.svg";